// extracted by mini-css-extract-plugin
export var Hurry = "DiabetesQuiz-module--Hurry--ztd0O";
export var actionContainer = "DiabetesQuiz-module--actionContainer--wKQQJ";
export var belowTxt = "DiabetesQuiz-module--belowTxt--61Lbx";
export var belowTxt2 = "DiabetesQuiz-module--belowTxt2--yRwRF";
export var btnCon = "DiabetesQuiz-module--btnCon--FYEx8";
export var btntxt = "DiabetesQuiz-module--btntxt--omfy0";
export var chartImg = "DiabetesQuiz-module--chartImg--rIt9e";
export var con = "DiabetesQuiz-module--con--j6S2W";
export var conHeight = "DiabetesQuiz-module--conHeight--c-uS2";
export var conWithDxHeight = "DiabetesQuiz-module--conWithDxHeight--cm-pO";
export var connHeight = "DiabetesQuiz-module--connHeight--vaS1w";
export var connnHeight = "DiabetesQuiz-module--connnHeight--BCrDU";
export var ctaBtn = "DiabetesQuiz-module--ctaBtn--LPrPm";
export var ctaCon = "DiabetesQuiz-module--ctaCon--Kb1-L";
export var ctaConTxt = "DiabetesQuiz-module--ctaConTxt--zumas";
export var curve = "DiabetesQuiz-module--curve--tYjP3";
export var days = "DiabetesQuiz-module--days--E+jjL";
export var designation = "DiabetesQuiz-module--designation--2YauU";
export var designationSecond = "DiabetesQuiz-module--designationSecond--QG-Cg";
export var details = "DiabetesQuiz-module--details--KN9eH";
export var dr1Img = "DiabetesQuiz-module--dr1Img--mAxHp";
export var drName = "DiabetesQuiz-module--drName--tAXeO";
export var formInput = "DiabetesQuiz-module--formInput--Rz0FC";
export var form_heading = "DiabetesQuiz-module--form_heading--NbvgN";
export var form_p = "DiabetesQuiz-module--form_p--8Fggw";
export var giftIcon = "DiabetesQuiz-module--giftIcon--y5mxf";
export var heading_text = "DiabetesQuiz-module--heading_text--G2U31";
export var logoConHeight = "DiabetesQuiz-module--logoConHeight--cR-Sk";
export var logoImg = "DiabetesQuiz-module--logoImg--xHLhv";
export var maleImg = "DiabetesQuiz-module--maleImg--OX5F3";
export var option = "DiabetesQuiz-module--option--L-O7X";
export var option_selected = "DiabetesQuiz-module--option_selected--wdhWD";
export var priceTxt = "DiabetesQuiz-module--priceTxt--H9R36";
export var progressBar = "DiabetesQuiz-module--progressBar--xFgHF";
export var progressHighBar = "DiabetesQuiz-module--progressHighBar--OImxO";
export var question = "DiabetesQuiz-module--question--Y6Xh7";
export var resultCon = "DiabetesQuiz-module--resultCon--e+Xb4";
export var resultConTxt = "DiabetesQuiz-module--resultConTxt--S8AaY";
export var resultConTxt1 = "DiabetesQuiz-module--resultConTxt1--kKhBn";
export var resultWarn = "DiabetesQuiz-module--resultWarn--hekEa";
export var result_heading = "DiabetesQuiz-module--result_heading--0PR68";
export var result_p = "DiabetesQuiz-module--result_p--YeDtT";
export var strikRs = "DiabetesQuiz-module--strikRs--KhjvK";
export var submitBtn = "DiabetesQuiz-module--submitBtn--cxRyN";
export var text1 = "DiabetesQuiz-module--text1--d3FQS";
export var text2 = "DiabetesQuiz-module--text2--lYGxR";
export var title1 = "DiabetesQuiz-module--title1--Eb4e4";
export var title2 = "DiabetesQuiz-module--title2--ExgG9";
export var treated = "DiabetesQuiz-module--treated--NzHKQ";
export var treated2 = "DiabetesQuiz-module--treated2--8UMPK";
export var userName = "DiabetesQuiz-module--userName--e4PBz";
export var webDetailsCon = "DiabetesQuiz-module--webDetailsCon--a9CED";
export var webDr2Con = "DiabetesQuiz-module--webDr2Con--tT2cQ";
export var webDrCon = "DiabetesQuiz-module--webDrCon--AwflP";
export var webiCon = "DiabetesQuiz-module--webiCon--WXzW9";
export var webiConn = "DiabetesQuiz-module--webiConn--6yPnX";
export var webiDetailImg = "DiabetesQuiz-module--webiDetailImg--YwDm6";
export var webiTit = "DiabetesQuiz-module--webiTit--5re3o";
export var webiTit2 = "DiabetesQuiz-module--webiTit2--7LGSZ";
export var webiTxt1 = "DiabetesQuiz-module--webiTxt1--PbGvy";
export var webititle = "DiabetesQuiz-module--webititle--U30zW";
export var webititle2 = "DiabetesQuiz-module--webititle2--P1Zfp";
export var whiteFontArrow = "DiabetesQuiz-module--whiteFontArrow--Hs7tY";
export var yoe = "DiabetesQuiz-module--yoe--eYwg9";